export default "__VITE_ASSET__3522cd57__"